<template>
    <b-carousel
              v-model="slide"
              :interval="4000"
              controls
              indicators
              background="#ababab"
              img-width="1024"
              :img-height="currentField.controlHeight"
              style="text-shadow: 1px 1px 2px #333;"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
        <b-carousel-slide
            :style="`height: ${currentField.controlHeight}px;`"
            v-for="(item, index) in currentField.items" :key="index"
            :img-src="item.url"
        ></b-carousel-slide>
        </b-carousel>
</template>

<script>
export default {
  name: 'Button',
  props: ['currentField'],
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>
<style scoped>

</style>
